<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window m-msg-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <div class="dialog-body">
                    <div class="dialog-text">
                        <p v-if="type == 1" >花费<b>19</b><em class="icon i-m3b"></em>购买小队特惠包么？</p>
                        <p v-if="type == 2" >花费<b>99</b><em class="icon i-m3b"></em>购买军团内购包(限1次)么？</p>
                    </div>

                    <div class="u-btn ok" v-if="type == 1" @click="buy_team()"></div>
                    <div class="u-btn ok" v-if="type == 2" @click="buy_corp()"></div>
                </div>   
            </div>         
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            name : '',
            code : '',
            cost : 120,
            type : 1,
        }
    }, 
    methods : {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        buy_team (){
            this.$axios.get(ajax_url_map.buy)
            .then(
                res => {

                    //$_setBuyFlag
                    this.$update_evt();
                    this.$toast('购买成功~');
                    this.destroyElement ();
                },
                rej => {
                    this.$toast(rej.message);
                    this.$update_evt();
                }
            )
        },
        buy_corp (){
            this.$axios.get(ajax_url_map.corp_pack)
            .then(
                res => {
                    this.$update_evt();
                    this.$toast('购买成功~');
                    this.destroyElement ();
                },
                rej => {
                    this.$toast(rej.message);
                }
            )
        },                          
    },
}
</script>

<style scoped>
/* share */
.m-msg-modal {
    width: 504px;
    height: 304px;
    background-image: url(~@/assets/images/utils/bg-modal-smsg.png);
}

.dialog-wrapper{
    padding: 90px 40px 0;
}

.dialog-text {
    font-size: 22px;
    color: #c03b20;
    text-align: center;
    word-break: break-all;
}

.dialog-text p{
    color: #c03b20;
    text-align: center;    
    margin-bottom: 4px;
}

.dialog-text b{
    color: #d45c3d;
}

.icon{
    display: inline-block;
    width: 21px;
    height: 22px;
    margin: 0 5px;
    background-image: url(~@/assets/images/pc/icon-m3b.png);
    /* vertical-align: sub; */
}

.u-btn.ok {
    position: absolute;
    left: 50%;
    bottom: 42px;
    width: 222px;
    height: 66px;
    margin-left: -111px;
    background-image: url(~@/assets/images/utils/btn-ok.png);
}
</style>


// WEBPACK FOOTER //
// src/components/ComfirmBuy/msgModal.vue